import { render, staticRenderFns } from "./PromotionSubsetName.vue?vue&type=template&id=4d40e9f8&"
import script from "./PromotionSubsetName.vue?vue&type=script&lang=ts&"
export * from "./PromotionSubsetName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports